import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { AppRoutes } from '../../constants/AppConstant';
import { toastError } from '../../service/Toast';

/**
 * Old emailed reset links (`/reset-password?token=...`) are no longer used:
 * admins now reset their password with a 6-digit email code on "Forgot password?".
 */
const ResetPassword = () => {
  const history = useHistory();

  useEffect(() => {
    toastError(
      'Password reset links are no longer used. Enter your email to get a 6-digit verification code.'
    );
    history.replace(AppRoutes.ForgotPassword);
  }, [history]);

  return null;
};

export default ResetPassword;
